<template>
  <div class="dropdowns-special">
    <deal-information
      ref='dealInfo'
      :type="'cirt'"
      :shownTypes="['CIRT']"
      :inputError='inputError'
      :validDeal.sync='validDeal'
      :report1='report1'
      @dealNameChange='dealName = $event'
      @activityMonthChange='activityMonth = $event'
      @cprChange='cpr = $event'
      @cdrChange='cdr = $event'
      @lossSeverityChange='lossSeverity = $event'
      @delinquencyChange='delinquency = $event'
      @liborChange='libor = $event'
      @hpiChange='hpi = $event'
      @NationalUnemploymentForecastChange='NationalUnemploymentForecast = $event'
      @hpaChange='hpa = $event'
      @2YrTsyChange='twoYrTsy = $event'
      @10YrTsyChange='tenYrTsy = $event'
      @tuneCprChange='tuneCpr = $event'
      @tuneCdrChange='tuneCdr = $event'
      @tuneSeverityChange='tuneSeverity = $event'
      @mtg15Change='mtg15 = $event'
      @mtg30Change='mtg30 = $event'
      @cancellationChange='onCancellationChange($event)'
      @cancellationDateChange='onCancellationDateChange($event)'
      @show-spinner='ObjSpinnerState.isOn = true'
      @hide-spinner='ObjSpinnerState.isOn = false'
      @scenarioChange='selectedScenario = $event'
    />
    <cirt
      v-if='validDeal'
      :dealName='dealName'
      :activityMonth='activityMonth'
      :cpr='cpr'
      :cdr='cdr'
      :lossSeverity='lossSeverity'
      :delinquency='delinquency'
      :libor='libor'
      :hpi='hpi'
      :NationalUnemploymentForecast='NationalUnemploymentForecast'
      :hpa='hpa'
      :twoYrTsy='twoYrTsy'
      :tenYrTsy='tenYrTsy'
      :tuneCpr='tuneCpr'
      :tuneCdr='tuneCdr'
      :tuneSeverity='tuneSeverity'
      :mtg15='mtg15'
      :mtg30='mtg30'
      :cancellation='cancellation'
      :cancellationDate='cancellationDate'
      :selectedScenario='selectedScenario'
      @inputError='inputError = $event'
      @show-spinner='ObjSpinnerState.isOn = true'
      @hide-spinner='ObjSpinnerState.isOn = false'
      @setCookies='$refs.dealInfo.setCookies()'
    />
  </div>
</template>

<script>
import DealInformation from './cirt_index';
import Cirt            from './Cirt';
import ReportsNames    from '@/constants/reportsNames';
import ObjSpinnerState from "@/components/common/spinner/ObjSpinnerState";

export default {
  data() {
    return {
      dealName:                     '',
      activityMonth:                '',
      cpr:                          [],
      cdr:                          [],
      lossSeverity:                 [],
      delinquency:                  [],
      libor:                        [],
      hpi:                          [],
      NationalUnemploymentForecast: [],
      hpa:                          [],
      twoYrTsy:                     '',
      tenYrTsy:                     '',
      tuneCpr:                      [1],
      tuneCdr:                      [1],
      tuneSeverity:                 [1],
      mtg15:                        [],
      mtg30:                        [],
      cancellation:                 false,
      cancellationDate:             '',
      inputError:                   '',
      selectedScenario:             null,
      validDeal:                    false,
      ObjSpinnerState
    };
  },
  computed:   {
    report1() {
      return {
        pReportName:          ReportsNames.Historical.CIRT,
        pReportParams:        [
          {
            'DbName': 'deal',
            'Value':  this.$route.query.dealName
          }
        ],
        flagShowOwnRunButton: false,
        pLabelRunButton:      `Run ${ReportsNames.Historical.CIRT} Report`
      };
    }
  },
  methods:    {
    onCancellationChange:     function (value) {
      this.cancellation = value;
    },
    onCancellationDateChange: function (value) {
      this.cancellationDate = value
    }
  },
  components: {
    DealInformation,
    Cirt
  }
};
</script>
